// extracted by mini-css-extract-plugin
module.exports = {"dingTalkDaBtn":"style_dingTalkDaBtn__mjWpO"};